import type { LicenceOrderInput } from '../api/admin/types';

import { emptyLicenceDraft, integrationsFrom, LIMIT_FIELDS, type LicenceDraft } from './licenceDraft';
import { parseOptionalWholeNumber, parseWholeNumber } from './parse';

/** A licence order as the form edits it: months and the four limits, as text (R0006 D-03). */
export type LicenceOrderDraft = LicenceDraft & { months: string };

export const MAX_ORDER_MONTHS = 60;

export const emptyLicenceOrderDraft = (): LicenceOrderDraft => ({ ...emptyLicenceDraft(), months: '12' });

/** The input the API takes, or `null` when a field cannot be read. */
export const licenceOrderInputFrom = (draft: LicenceOrderDraft): LicenceOrderInput | null => {
  const months = parseWholeNumber(draft.months);
  const limits = LIMIT_FIELDS.map((field) => parseOptionalWholeNumber(draft[field]));
  const integrations = integrationsFrom(draft.integrationLinks);

  if (
    integrations === undefined ||
    months === undefined ||
    months < 1 ||
    months > MAX_ORDER_MONTHS ||
    limits.some((limit) => limit === undefined)
  ) {
    return null;
  }

  const [maxCompanies, maxSubUsers, maxProducts, maxTotalStock] = limits as Array<number | null>;

  return {
    months,
    maxCompanies,
    maxSubUsers,
    maxProducts,
    maxTotalStock,
    notes: draft.notes.trim() === '' ? null : draft.notes.trim(),
    integrations,
  };
};
